import './fontawesome';
import './tooltips';
import './popovers';
import './sliders';
import './sticky';
import './paginate';
import './process-data-load-attr';